<button
  boelsButton
  variant="secondary"
  action="upward"
  [alwaysShowActionIcon]="true"
  (click)="backToTop()"
>
  {{ 'productList.backToTopBtn' | transloco }}
</button>
